import { render, staticRenderFns } from "./IbDetailSkeleton.vue?vue&type=template&id=03e2e2ad&scoped=true&"
import script from "./IbDetailSkeleton.vue?vue&type=script&lang=js&"
export * from "./IbDetailSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./IbDetailSkeleton.vue?vue&type=style&index=0&id=03e2e2ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2e2ad",
  null
  
)

export default component.exports